package feature.business.repository

import feature.business.model.Business
import feature.sync.BusinessAnalytics
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

class BusinessRepository {
    val analyticsLiveData: MutableStateFlow<ArrayList<BusinessAnalytics>> = MutableStateFlow(
        arrayListOf()
    )
    val analytics: StateFlow<ArrayList<BusinessAnalytics>>
        get() = analyticsLiveData

    val createBusinessState: MutableStateFlow<Business> = MutableStateFlow(Business())

    val businessLiveData: MutableStateFlow<Business> = MutableStateFlow(Business())
    val business: StateFlow<Business>
        get() = businessLiveData

    val allBusinessLiveData: MutableStateFlow<List<Business>> = MutableStateFlow(arrayListOf())
    val allBusiness: StateFlow<List<Business>>
        get() = allBusinessLiveData
}